import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Star } from 'lucide-react';
const faqs = [{
  q: '¿Necesito equipo de gimnasio?',
  a: 'No, los ejercicios se pueden hacer en casa con tu propio peso.'
}, {
  q: '¿Es difícil de seguir?',
  a: 'No, se basa en comer comida real en el orden correcto.'
}, {
  q: '¿Puedo tomar café?',
  a: 'Sí, te enseñamos cómo hacerlo sin estresar tus hormonas.'
}, {
  q: '¿Tengo que comprar suplementos caros?',
  a: 'No, el enfoque es 100% nutrición y estilo de vida.'
}];
export function ProofFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-white" data-id="element-149">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-150">
        {/* Proof Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-cream rounded-3xl p-8 md:p-12 mb-20 text-center shadow-sm border border-brand-accent/50" data-id="element-151">
          <div className="flex justify-center gap-1 mb-6" data-id="element-152">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-brand-terracotta text-brand-terracotta" data-id="element-153" />)}
          </div>
          <h2 className="text-3xl font-bold mb-6 text-brand-text" data-id="element-154">
            Qué cambia en 7 días
          </h2>
          <p className="text-lg md:text-xl text-brand-text/80 leading-relaxed italic" data-id="element-155">
            "Sentirás una reducción notable en la inflamación abdominal. La
            'niebla mental' desaparece y tus niveles de energía se mantienen
            estables desde la mañana hasta la noche, sin necesidad de recurrir a
            snacks azucarados a media tarde."
          </p>
        </motion.div>

        {/* FAQ Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-156">
          <h2 className="text-3xl font-bold mb-8 text-center text-brand-text" data-id="element-157">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-158">
            {faqs.map((faq, index) => <div key={index} className="border border-brand-accent/40 rounded-2xl overflow-hidden bg-white" data-id="element-159">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-160">
                  <span className="font-semibold text-brand-text text-lg" data-id="element-161">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-terracotta transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-162" />
                </button>
                <AnimatePresence data-id="element-163">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-164">
                      <div className="px-6 pb-5 text-brand-text/70 leading-relaxed" data-id="element-165">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}